import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Projects } from "../components/Projects";
import { GallerySection } from "../components/GallerySection";
import { Stats } from "../components/Stats";
import { Contact } from "../components/Contact";
import { MapSection } from "../components/MapSection";
import { Footer } from "../components/Footer";

const ASSET = "https://customer-assets-lqy194kg.emergentagent.net/job_construction-hub-734/artifacts";

const rimsPhotos = [
  { src: `${ASSET}/zytk6mlq_m2.jpeg`, label: "Junction boxes & conduit — slab layout" },
  { src: `${ASSET}/syxebwl8_m3.jpeg`, label: "Conduit routing across the beam grid" },
  { src: `${ASSET}/vx7orhvz_m4.jpeg`, label: "Full-slab conduit network — day shift" },
  { src: `${ASSET}/pjojl8ab_m5.jpeg`, label: "Night shift — pre-pour electrical inspection" },
  { src: `${ASSET}/hrxoi76t_m6.jpeg`, label: "Conduit runs ready for slab casting" },
];

const furniturePhotos = [
  { src: `${ASSET}/yvxh0tp0_i1.jpeg`, label: "Living room — custom sofa & ceiling lighting" },
  { src: `${ASSET}/jl6vbxg4_i2.jpeg`, label: "CNC fluted feature wall — in progress" },
  { src: `${ASSET}/tg98y6l2_i3.jpeg`, label: "Modular kitchen — completed handover" },
  { src: `${ASSET}/jc9x7dl9_i4.jpeg`, label: "Wardrobe installation — finishing stage" },
  { src: `${ASSET}/5e5fybwy_i5.jpeg`, label: "Kids' room wardrobe & dresser — completed" },
];

const plumbingPhotos = [
  { src: `${ASSET}/e7lz3pl4_i6.jpeg`, label: "Ceiling pipe runs with cove lighting — residential tower" },
  { src: `${ASSET}/6ivisz6n_i7.jpeg`, label: "High-rise external drainage stacks" },
  { src: `${ASSET}/youfat3o_i8.jpeg`, label: "Plumbing shaft — vertical distribution" },
  { src: `${ASSET}/ui9g9z4k_i9.webp`, label: "Facade drainage network — branch connections" },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0B0C0E] text-[#F3F4F6]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Stats />
        <Projects />
        <GallerySection
          id="rims-gallery"
          eyebrow="Real work · RIMS Hospital, Manipur"
          title="Electrical work,"
          accent="shot on site."
          description="Unedited photos from our RIMS Hospital electrical scope — tap any photo to view it full-screen."
          tag="RIMS"
          photos={rimsPhotos}
          dark
        />
        <GallerySection
          id="furniture-gallery"
          eyebrow="Real work · Furniture & Interiors"
          title="Furniture & interiors,"
          accent="delivered."
          description="Living rooms, modular kitchens, wardrobes and feature walls crafted by the Gativan team — tap to view full-screen."
          tag="FURN"
          photos={furniturePhotos}
        />
        <GallerySection
          id="plumbing-gallery"
          eyebrow="Real work · Plumbing & Piping"
          title="Plumbing systems,"
          accent="floor to facade."
          description="Pipe runs, drainage stacks and plumbing shafts from our live residential towers — tap to view full-screen."
          tag="PLMB"
          photos={plumbingPhotos}
          dark
          featureFirst={false}
        />
        <Contact />
        <MapSection />
      </main>
      <Footer />
    </div>
  );
}
